import { navigate } from '../router.js';
import { monthGrid, monthTitle, shiftMonth, fmtDate, WEEKDAYS } from '../../lib/dates.js';

const WEEKDAY_NAMES = ['ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota', 'nedelja'];

// The app's one bold element: the month, Monday first. cells(date) → { label?, working?, count?, noGuide? }.
export function MonthGrid({ month, cells, selected, onSelect, today }) {
  const go = (n) => navigate(`${location.pathname}?month=${shiftMonth(month, n)}`, { replace: true });
  return (
    <table class="month">
      <caption>
        <div class="month-head">
          <span class="month-title">{monthTitle(month)}</span>
          <button type="button" class="month-step" aria-label="Prethodni mesec" onClick={() => go(-1)}>‹</button>
          <button type="button" class="month-step" aria-label="Sledeći mesec" onClick={() => go(1)}>›</button>
        </div>
      </caption>
      <thead>
        <tr>{WEEKDAYS.map((w, i) => <th key={i} scope="col" abbr={WEEKDAY_NAMES[i]}>{w}</th>)}</tr>
      </thead>
      <tbody>
        {monthGrid(month).map((week) => (
          <tr key={week.find(Boolean)}>
            {week.map((date, i) => {
              if (!date) return <td key={i} class="day-out" />;
              const c = cells(date) ?? {};
              const cls = ['day', c.working && 'working', date === today && 'today'].filter(Boolean).join(' ');
              return (
                <td key={date}>
                  <button type="button" class={cls} aria-label={fmtDate(date)} aria-pressed={date === selected ? 'true' : 'false'}
                    onClick={() => onSelect(date)}>
                    <span class="day-num">{Number(date.slice(8))}</span>
                    {c.label && <span class="day-label">{c.label}</span>}
                    {c.count > 0 && <span class={c.noGuide ? 'day-count no-guide' : 'day-count'}>{c.count}</span>}
                  </button>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
